module.exports = __webpack_public_path__ + "static/media/Government house, albumen print by Bourne.49de406a.jpg";